<div class="filters" [formGroup]="filters">
    <div class="search">
      <label for="search">Поиск</label>
      <input id="search" type="text" formControlName="search" />
    </div>
    <div class="advanced" *ngIf="hasCustomFilters">
      <button type="button" (click)="showFilters()" [class.filled]="isFiltersApplied"><span>Фильтр</span></button>
    </div>
</div>
